import { Component, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import { ExcelService } from 'src/app/core/services/excel.service';
import { LocalStorageService } from 'ngx-webstorage';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.css'],
})

export class PerformanceComponent implements OnInit {
  public type_organisation: string;
  public organisation: string;
  public nbre_agents: string;
  public showPerformances = false;
  public detailsPerformances = false;
  public performances: any;
  public listOrganisation: any;
  public listDetails: any;
  public selectedOrganisation: any;
  public settingsOrganisation = {};
  public key = 'code';
  public reverse = false;
  public p = 1;
  public filter: string;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  constructor(
    private _service: AppService,
    private _loader: LoadingBarService,
    private toastrService: ToastrService,
    private _excelService: ExcelService,
    private storage: LocalStorageService
  ) { }

  public ngOnInit() {
    this.settingsOrganisation = {
      singleSelection: true,
      text: 'Selectionner l\'organisation-eia',
      classes: 'myclass custom-class',
      labelKey: 'code',
      enableSearchFilter: true,
      searchBy: ['code'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune organisation-eia disponible'
    };
  }

  public onSelectTypeOrganisation(item) {
    this.type_organisation = item;
    if (item === 'direction') return this.getAllDirection()
    else return this.getAllStructure();
  }

  public getAllStructure() {
    this._service.postData('capital-humain/structures/all', {})
      .subscribe(
        res => {
          if (res.error === false) {
            this.listOrganisation = res.data;
          } else {
            console.log(res.message);
          }
        }, err => {
          this.toastrService.error(err.error.message);
        }
      );
  }

  public getAllDirection() {
    this._service.getData('capital-humain/structures/direction')
      .subscribe(
        res => {
          if (res.error === false) {
            this.listOrganisation = res.data;
          } else {
            console.log(res.message);
          }
        }, err => {
          this.toastrService.error(err.error.message);
        }
      );
  }

  public onSelectOrganisation(item) {
    this.organisation = item.code;
  }

  public rechercher() {
    this._loader.start();
    const obj = {
      campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
      type_organisation: this.type_organisation,
      organisation: this.organisation,
    };
    this._service.postData('reporting/performance', obj).subscribe(
      (res) => {
        if (res.error === false) {
          this._loader.stop();
          console.log(res);
          this.performances = res.data;
          this.nbre_agents = res.data.nbre_agent;
          this.showPerformances = true;
        } else {
          swal.fire({
            title: 'HR PERF',
            type: 'warning',
            text: res.message,
            showCancelButton: false,
            confirmButtonText: 'ok',
          });
          this._loader.stop();
          this.showPerformances = false;
        }
      },
      (err) => {
        this.toastrService.error(err.error.message);
        this._loader.stop();
        this.showPerformances = false;
      }
    );
  }

  public showDetails(data) {
    if (data.length <= 0) {
      swal.fire({
        title: 'HR PERF',
        type: 'info',
        text: 'Pas de détails disponible',
        showCancelButton: false,
        confirmButtonText: 'ok',
      });
    } else {
      this.detailsPerformances = !this.detailsPerformances;
      this.showPerformances = !this.showPerformances;
      this.listDetails = data;
    }
  }

  public exporterFiche() {
    this._loader.start();
    const arrayDetailsPerformances = [];
    for (let i = 0; i < this.listDetails?.length; i++) {
      arrayDetailsPerformances.push(
        {
          'Matricule': this.listDetails[i].matricule,
          'Nom & Prénoms': this.listDetails[i].qualite + ' ' + this.listDetails[i].nom + ' ' + this.listDetails[i].prenoms,
          'Note': this.listDetails[i].note,
          'Classement': i + 1,
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayDetailsPerformances, 'reporting_details_performances');
    this._loader.stop();
  }

  public retourAffichagePerformances() {
    this.detailsPerformances = !this.detailsPerformances;
    this.showPerformances = !this.showPerformances;
  }
}
